import React, { PureComponent } from 'react';
import TableHeader from './TableHeader.jsx';
import TableBody from './TableBody.jsx';

class Table extends PureComponent {
    constructor(props) {
        super(props);
        
    }
    
    render() {
        return (
            <table className="table table-striped top-separator-xs">
                <TableHeader />
                <TableBody 
                    data={this.props.data}
                    tarjetas={this.props.tarjetas} 
                    edicionClienteAdicional={this.props.edicionClienteAdicional}
                    borrarClienteAdicional={this.props.borrarClienteAdicional}
                    confirmarClienteTarjeta={this.props.confirmarClienteTarjeta}
                    />
            </table>
     )  
    }
};

export default Table;